.actions {
  display: flex;
  align-items: center;
  column-gap: 22px;
}
